// src/api/mentoringApi.js
//
// 1:1 Mentoring API calls. Faculty endpoints use the platform's regular
// `api` instance (Bearer access_token attached automatically by the
// existing interceptor). Student endpoints reuse the AskOS student token
// convention, matching frontend/src/api/liveSessionsApi.js.
import api from './api';
import { askosAuthHeader } from '../askos/askosApi';

// ── Faculty ──────────────────────────────────────────────────────────────

export const publishMentoringSlots = (slug, slotStarts) =>
  api.post(`/tenant/${slug}/faculty/mentoring/slots`, { slot_starts: slotStarts }).then(r => r.data);

export const listMyMentoringSlotsFaculty = (slug) =>
  api.get(`/tenant/${slug}/faculty/mentoring/slots`).then(r => r.data);

export const cancelMentoringSlotFaculty = (slug, slotId, reason = '') =>
  api.post(`/tenant/${slug}/faculty/mentoring/slots/${slotId}/cancel`, { reason }).then(r => r.data);

export const joinMentoringSlotFaculty = (slug, slotId) =>
  api.post(`/tenant/${slug}/faculty/mentoring/slots/${slotId}/join`).then(r => r.data);

// ── Student (AskOS) ──────────────────────────────────────────────────────

export const listMentoringFaculty = (slug) =>
  api.get(`/tenant/${slug}/askos/mentoring/faculty`, { headers: askosAuthHeader() }).then(r => r.data);

export const listOpenMentoringSlots = (slug, facultyUserId = null) =>
  api.get(`/tenant/${slug}/askos/mentoring/slots`, {
    headers: askosAuthHeader(),
    params: facultyUserId ? { faculty_user_id: facultyUserId } : {},
  }).then(r => r.data);

export const bookMentoringSlot = (slug, slotId) =>
  api.post(`/tenant/${slug}/askos/mentoring/slots/${slotId}/book`, {}, { headers: askosAuthHeader() }).then(r => r.data);

export const cancelMentoringSlotStudent = (slug, slotId, reason = '') =>
  api.post(`/tenant/${slug}/askos/mentoring/slots/${slotId}/cancel`, { reason }, { headers: askosAuthHeader() }).then(r => r.data);

export const myMentoringBookings = (slug) =>
  api.get(`/tenant/${slug}/askos/mentoring/my-bookings`, { headers: askosAuthHeader() }).then(r => r.data);

export const joinMentoringSlotStudent = (slug, slotId) =>
  api.post(`/tenant/${slug}/askos/mentoring/slots/${slotId}/join`, {}, { headers: askosAuthHeader() }).then(r => r.data);
